import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { retry } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UploadService = /** @class */ (function () {
    function UploadService(http) {
        this.http = http;
    }
    UploadService.prototype.upload = function (params) {
        return this.http
            .post(environment.UPLOAD_URL + '/s3-passthrough-upload', params)
            .pipe(retry(2))
            .toPromise();
    };
    UploadService.prototype.uploadWithCredentials = function (_a) {
        var fields = _a.fields, baseUrl = _a.baseUrl, file = _a.file;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formData = this.buildFormData({ fields: fields, file: file });
                        return [4 /*yield*/, this.http.post(baseUrl, formData, {
                                observe: 'body',
                                responseType: 'text',
                            }).toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadService.prototype.buildFormData = function (_a) {
        var e_1, _b;
        var fields = _a.fields, file = _a.file;
        var form = new FormData();
        try {
            for (var _c = tslib_1.__values(Object.entries(fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = tslib_1.__read(_d.value, 2), key = _e[0], value = _e[1];
                form.append(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        form.append('file', file);
        return form;
    };
    UploadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UploadService_Factory() { return new UploadService(i0.ɵɵinject(i1.HttpClient)); }, token: UploadService, providedIn: "root" });
    return UploadService;
}());
export { UploadService };
